import { Icon } from '@driftt/tide-icons'
import { pluralize } from 'humanize-plus'
import { isEmpty, keys } from 'ramda'
import React from 'react'

import { BlockUpdateVersionData } from 'api/blocks'
import CollapsibleContent from 'components/CollapsibleContent'

import styles from './styles.module.css'

const CollapsibleBlockChanges = ({
  blockChanges,
}: {
  blockChanges: BlockUpdateVersionData
}) => {
  const {
    currentBlockOutputConfiguration,
    latestBlockOutputConfiguration,
    addedOutputKeys,
    removedOutputKeys,
    updatedOutputKeys,
  } = blockChanges

  return (
    <CollapsibleContent title="View structural changes">
      <div className={styles.collapsibleBlockChanges}>
        <div className={styles.collapsibleBlockChangesHeaderRow}>
          <div className={styles.collapsibleBlockChangesHeader}>
            Original block
          </div>
          <div className={styles.collapsibleBlockChangesHeader}>
            Updated block
          </div>
        </div>
        {(!isEmpty(addedOutputKeys) || !isEmpty(removedOutputKeys)) && (
          <div className={styles.collapsibleBlockChangesOutputsRow}>
            <div className={styles.collapsibleBlockChangesOutputsColumn}>
              {keys(currentBlockOutputConfiguration).length}{' '}
              {pluralize(keys(currentBlockOutputConfiguration).length, 'path')}
              <Icon
                className={styles.collapsibleBlockChangesArrow}
                name="arrow-2-right"
                height="16"
                width="16"
              />
            </div>
            <div>
              {keys(latestBlockOutputConfiguration).length}{' '}
              {pluralize(keys(latestBlockOutputConfiguration).length, 'path')} (
              {[
                `${addedOutputKeys.length} added`,
                `${removedOutputKeys.length} removed`,
              ]
                .filter((copy) => copy[0] !== '0')
                .join(', ')}
              )
            </div>
          </div>
        )}
        {!isEmpty(updatedOutputKeys) && (
          <div className={styles.collapsibleBlockChangesOutputsRow}>
            <div className={styles.collapsibleBlockChangesOutputsColumn}>
              <div className={styles.collapsibleBlockChangesNA}>N/A</div>
              <Icon
                className={styles.collapsibleBlockChangesArrow}
                name="arrow-2-right"
                height="16"
                width="16"
              />
            </div>
            <div>
              {updatedOutputKeys.length} conversation status{' '}
              {pluralize(updatedOutputKeys.length, 'change')}
            </div>
          </div>
        )}
      </div>
    </CollapsibleContent>
  )
}

export default CollapsibleBlockChanges
